import api from "api";

const stationOrders = {
    list:         (slug, params = {}) =>
        api().get(`/establishments/${slug}/station-orders`, { params }),
    updateStatus: (slug, id, status) =>
        api().put(`/establishments/${slug}/station-orders/${id}/status`, { status }),
};

export default stationOrders;
